// MM-42243: curated language (culture) choices for the bulk invite-load page's Language Code dropdown. There is no
// dbo.Language table and the SPA's i18n phrases are DB-sourced (no local locale list to reuse), so this list is
// compiled from the cultures the server actually supports — RequestLocalizationOptions.SupportedCultures in
// ZBEdge.App/ServiceExtensions.cs (the set Program.cs wires into UseRequestLocalization). The `code` is copied into
// each invite row's LanguageCode cell and must match a supported culture; `label` is display only. Keep in sync with
// ServiceExtensions.cs if the supported-cultures list changes. (uz-UZ is registered only conditionally on the server,
// so it is intentionally omitted here.)

export interface SupportedLanguageOption {
  code: string;
  label: string;
}

export const DefaultLanguageCode = 'en-US';

export const SupportedLanguages: SupportedLanguageOption[] = [
  { code: 'ca-ES', label: 'Catalan (Spain)' },
  { code: 'de-AT', label: 'German (Austria)' },
  { code: 'de-CH', label: 'German (Switzerland)' },
  { code: 'de-DE', label: 'German (Germany)' },
  { code: 'de-LU', label: 'German (Luxembourg)' },
  { code: 'en-US', label: 'English (United States)' },
  { code: 'en-AE', label: 'English (U.A.E.)' },
  { code: 'en-AU', label: 'English (Australia)' },
  { code: 'en-CA', label: 'English (Canada)' },
  { code: 'en-CH', label: 'English (Switzerland)' },
  { code: 'en-CX', label: 'English (Saudi Arabia)' },
  { code: 'en-GB', label: 'English (United Kingdom)' },
  { code: 'en-IE', label: 'English (Ireland)' },
  { code: 'en-IN', label: 'English (India)' },
  { code: 'en-NZ', label: 'English (New Zealand)' },
  { code: 'en-SG', label: 'English (Singapore)' },
  { code: 'en-ZA', label: 'English (South Africa)' },
  { code: 'es-ES', label: 'Spanish (Spain)' },
  { code: 'es-MX', label: 'Spanish (Mexico)' },
  { code: 'es-US', label: 'Spanish (United States)' },
  { code: 'fi-FI', label: 'Finnish (Finland)' },
  { code: 'fr-BE', label: 'French (Belgium)' },
  { code: 'fr-CA', label: 'French (Canada)' },
  { code: 'fr-CH', label: 'French (Switzerland)' },
  { code: 'fr-FR', label: 'French (France)' },
  { code: 'fr-LU', label: 'French (Luxembourg)' },
  { code: 'it-CH', label: 'Italian (Switzerland)' },
  { code: 'it-IT', label: 'Italian (Italy)' },
  { code: 'ja-JP', label: 'Japanese (Japan)' },
  { code: 'nl-BE', label: 'Dutch (Belgium)' },
  { code: 'nl-NL', label: 'Dutch (Netherlands)' },
  { code: 'pt-BR', label: 'Portuguese (Brazil)' },
  { code: 'sv-FI', label: 'Swedish (Finland)' },
  { code: 'sv-SE', label: 'Swedish (Sweden)' },
  { code: 'zh-CN', label: 'Chinese (China)' }
];
